import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export class RexController extends Controller {
  queryParams = ['studentGrade', 'contentLevel']

  @tracked studentGrade = 'all'

  @tracked contentLevel = 'all'
}

export default RexController

declare module '@ember/controller' {
  interface Registry {
    'reporting/ui-scope/rex': RexController
  }
}
